import React, { useState } from 'react';
import { TrendingUp, AlertTriangle, Activity, Settings, Archive } from 'lucide-react';
import CostAllocationDateReport from './CostAllocationDateReport';
import MissingBrokerData from './MissingBrokerData';
import DataQualityDiagnostic from './DataQualityDiagnostic';
import ActualCostSettings from './ActualCostSettings';

// CHA-338 — the legacy "Actual Cost" surface, parked under Admin → Archive. Actual Cost 2 is the
// go-forward primary from 7/1/26; this preserves one-click access to the pre-7/1/26 broker-file
// cost-allocation report + its Missing Data / Data Quality / Settings tabs. Nothing here changed
// functionally — it is the exact former Imports → Actual Cost section, relocated. The underlying
// callables, `cost_allocation_view`, and the `ac_*` tables are all untouched.
const TABS = [
  { id: 'cost-analysis', label: 'Cost Analysis', icon: TrendingUp },
  { id: 'missing-data', label: 'Missing Data', icon: AlertTriangle },
  { id: 'data-quality', label: 'Data Quality', icon: Activity },
  { id: 'settings', label: 'Settings', icon: Settings },
];

const subTabCls = (on) =>
  `flex items-center gap-1.5 px-4 py-2 text-[12.5px] -mb-px border-b-2 ${
    on ? 'text-carbon-ink font-semibold border-carbon-blue-60 bg-carbon-white' : 'text-carbon-gray-50 border-transparent hover:text-carbon-ink'
  }`;

export default function ArchivedActualCost() {
  const [tab, setTab] = useState('cost-analysis');
  return (
    <div>
      <div className="flex items-start gap-2.5 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 mb-3">
        <Archive className="h-4 w-4 text-amber-700 mt-0.5 shrink-0" />
        <div className="text-[13px] text-amber-900">
          <div className="font-semibold">Archived — legacy Actual Cost (pre-7/1/26)</div>
          <div className="text-amber-800">
            Superseded by <span className="font-medium">Actual Cost</span> (ACE-driven) for 7/1/26 forward. Kept for historical reference — the broker Duty/Charges file report, its overrides, and diagnostics are unchanged.
          </div>
        </div>
      </div>

      <div className="flex border-b border-carbon-border bg-carbon-gray-10">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.id} onClick={() => setTab(t.id)} className={subTabCls(tab === t.id)}>
              <Icon className="h-3.5 w-3.5" />
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'cost-analysis' && <CostAllocationDateReport embedded={true} />}
      {tab === 'missing-data' && <MissingBrokerData embedded={true} />}
      {tab === 'data-quality' && <DataQualityDiagnostic embedded={true} />}
      {tab === 'settings' && <ActualCostSettings />}
    </div>
  );
}
